import axios from "axios";

export const getPdf = ({queryKey}: any) => {
    const [_key, {queryPdfValues}] = queryKey;
    return axios.get('/external/network/digitalsign/pdf', {params: queryPdfValues});
}

export const handleNextStep = (params: any) => {
    return axios.post('/external/network/digitalsign/next', params);
}